import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'cmn-render-stars',
    templateUrl: './render-stars.component.html',
    styles: [],
})
export class RenderStarsComponent implements OnInit {
    @Input()
    numberOfStars: number | string;

    @Input()
    colorClass = 'm--font-brand';

    @Input()
    displayNumber = true;

    @Input()
    showEmptyStars = true;

    iterateNumbers: number[];
    iterateEmptyNumbers: number[];
    isHalf = false;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {}

    ngOnInit() {
        this.numberOfStars = Number(this.numberOfStars);
        if (this.numberOfStars % 1 !== 0) {
            this.isHalf = true;
            this.iterateEmptyNumbers = Array(4 - Math.floor(this.numberOfStars)).fill(0);
        } else {
            this.isHalf = false;
            this.iterateEmptyNumbers = Array(5 - Math.floor(this.numberOfStars)).fill(0);
        }
        this.iterateNumbers = Array(Math.floor(this.numberOfStars)).fill(1);
    }
}
